import { render, staticRenderFns } from "./ProductionArea.vue?vue&type=template&id=aeeae750&scoped=true&"
import script from "./ProductionArea.vue?vue&type=script&lang=js&"
export * from "./ProductionArea.vue?vue&type=script&lang=js&"
import style0 from "./ProductionArea.vue?vue&type=style&index=0&id=aeeae750&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeeae750",
  null
  
)

export default component.exports